import { motion } from "framer-motion";
import { BodyText, SaveButton } from "../../styles/global";
import { LeftSection, RightSection } from "../header/Header.style";
import { WrapperHeroTwo, TitleText, ButtonWrapper } from "./Hero.styles";

export const HeroSectionTwo = () => {
  return (
    <>
      <WrapperHeroTwo>
        <RightSection>
          <motion.div
            whileInView={{ scale: 1, opacity: 1 }}
            initial={{ scale: 0.5, opacity: 0 }}
            transition={{ duration: 1.2, stiffness: 1 }}
          >
            <img src="img/Frame 20.jpg" alt="" />
          </motion.div>
        </RightSection>

        <LeftSection>
          <TitleText>
            <div className="bodyTextAdjusted">
              Financial freedom for the gen z, millennials and elite aged.
            </div>

            <BodyText>
              Bonpellz is designed to match your lifestyle, with the aim of
              helping you with an incredible savings and investment packages to
              seamlessly hit target goals, make well meaning investment and
              gradually grow your wealth
            </BodyText>
            <div>
              <h4 style={{ fontWeight: "bold" }} className="smartSavings">
              Smart Savings built to seamlessly hit all target goals
              </h4>
            </div>

            <BodyText>
              Be a superb goal getter, explore the world of our well
              orchestrated smart saving plans to help you seamlessly hit target
              goals with speed. Earn 5% - 15% when you save on this smart
              savings plan
            </BodyText>
          </TitleText>

          <ButtonWrapper>
            <SaveButton to="/">Start Saving</SaveButton>
          </ButtonWrapper>
        </LeftSection>
      </WrapperHeroTwo>
    </>
  );
};
